export default "__VITE_ASSET__06824115__"